import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class Zone extends Model {
  static entity = "zones";
  static primaryKey = "uuid";
  static aosType = "ZONE";

  static typeKey = "zoneType";

  static types() {
    return {
      ZONE_FUSION: ZoneFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.attr(null),
      usage: this.attr([]),
      location: this.attr(null),
      waterproofSurface: this.attr(null),
      heatingMode: this.attr([]),
      isBuildingIdenticalHeatingMode: this.boolean(false),
      occupationPresence: this.attr(null),
      occupationPresentPerson: this.attr(null),
      occupationQuantity: this.attr(null),
      isAccessible: this.boolean(false),
      reason: this.attr(null),
      remarks: this.attr(null),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      tracerCompound: this.attr([]),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.attr(null),
      typology: this.attr("ZONE"),
      soilType: this.attr([]),
      locationInsideBuilding: this.attr(null),
      buildingFk: this.attr(null),
      outdoorSpaceFk: this.attr(null),
      reference: this.attr(null),
      isAsbestosRisk: this.boolean(false),
      ceilingHeight: this.attr(null),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      existenceOfAConstraint: this.boolean(false),
      constraintAccuracy: this.attr(null),
      temporality: this.attr(null),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class ZoneFusion extends Zone {
  static entity = "zoneFusions";
  static primaryKey = "uuid";
  static baseEntity = "zones";

  static fields() {
    return {
      ...super.fields(),
      zones: this.attr([]),
      zoneType: this.attr("ZONE_FUSION"),
    };
  }
}
